import React from "react";
import { changeParameter } from "../../../api_calls/TableauVisuals";
import { Box } from "@mui/material";
import SingleSelect from "../Selectors/SingleSelect";
import { updateStateData } from "../../../Store/actions";
import { useDispatch, useSelector } from "react-redux";

const checkoutDataOptions = [
    {
        value: "cap_counter",
        label: "CAP Counter"
    },
    {
        value: "cap_counter_no_outlier",
        label: "CAP Counter w/o Outliers"
    },
    {
        value: "basket_trolley",
        label: "Basket Trolley"
    },
    {
        value: "only_trolley",
        label: "Only Trolley"
    },
    {
        value: "trigger_witness_conversion",
        label: "Trigger Witness Conversion"
    },
    {
        value: "contact_cr",
        label: "Contact CR"
    },
    {
        value: "referencing",
        label: "Referencing"
    }
];

const CheckoutDataFilter = ({ reduxKeywordToSaveValue, redux_param_name }) => {
    const userStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [checkoutTypeSelection, setCheckoutTypeSelection] = React.useState({});
    const [dataLoaded, setDataLoaded] = React.useState(false);

    React.useEffect(() => {
        // sort options based on label in ascending order
        checkoutDataOptions.sort((a, b) => a.label.localeCompare(b.label));
        const selectedVal = typeof userStateData[reduxKeywordToSaveValue] !== "undefined" && typeof userStateData[reduxKeywordToSaveValue][redux_param_name] !== "undefined" ?
            checkoutDataOptions.filter(opt => opt.value === userStateData[reduxKeywordToSaveValue][redux_param_name])[0]
            : checkoutDataOptions[0]
        setCheckoutTypeSelection(selectedVal);

        setTimeout(() => {
            setDataLoaded(true);
        }, 1000);
    }, []);

    return dataLoaded ? (
        <Box sx={{ width: 220 }}>
            <SingleSelect
                enableFullWidth={true}
                label={"Checkout Data"}
                disableSearch={true}
                selectionCheck={(option, value) => option.label === value.label}
                options={checkoutDataOptions}
                defaultVal={checkoutTypeSelection}
                onChangeCall={(selectedOption) => {
                    setCheckoutTypeSelection(selectedOption);
                    dispatchAction(
                        updateStateData({
                            [reduxKeywordToSaveValue]: {
                                ...userStateData[reduxKeywordToSaveValue],
                                [redux_param_name]: selectedOption.value,
                            },
                        })
                    );
                }}
            />
        </Box>
    ) : (
        <></>
    );
};

export default CheckoutDataFilter;
